module.exports = __webpack_public_path__ + "img/PRIVATE-LABEL-thumb.c6751177.png";